exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#woIdentifier-left{width:7.2em}#woIdentifier-left,#woIdentifier-middle{vertical-align:left;text-align:left;float:left}#woIdentifier-middle{width:6.5em}#woRpt-left{width:15.2em;vertical-align:left;text-align:left;float:left}#xsmspacer{padding-top:1.5em}#woMain{margin:5px 3em;border:0;width:60em}span{font-weight:700}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/workOrderIdentifiers/WorkOrderIdentifiers.component.scss
// module id = ./src/app/workOrderIdentifiers/WorkOrderIdentifiers.component.scss
// module chunks = app